import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usersList: {
    paginated_results: [],
    counters: {
      total_users: 0,
      total_active_users: 0,
      total_pending_users: 0,
      total_banned_users: 0,
    },
    pagination: {
      active_page: 1,
      total_pages: 1,
      items_per_page: 10,
    },
  },
  userDetails: {},
};

export const usersManagementSlice = createSlice({
  name: "usersManagement",
  initialState: initialState,
  reducers: {
    getUsersList: (state, action) => {
      state.usersList = action.payload;
    },
    getUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },

    changePageNumberUsers: (state, action) => {
      state.usersList.pagination.active_page = action.payload;
    },
  },
});

export const selectUsersList = (state) => state.usersManagement.usersList;
export const selectUserDetails = (state) => state.usersManagement.userDetails;

export const { getUsersList, changePageNumberUsers, getUserDetails } =
  usersManagementSlice.actions;
export default usersManagementSlice.reducer;
